import EventEmitter from "eventemitter3";
import { WebGLCircularControl } from "../components/CircularControl";

const Menu = `
<canvas id='canvas'></canvas>
`;

export class MenuScreen extends EventEmitter {
  constructor() {
    super();
  }

  public addEventListeners() {
    const body = document.body as HTMLBodyElement
    body.style.margin = "0";
    body.style.padding = "0";
    const canvas = document.getElementById('canvas') as HTMLCanvasElement;
    canvas.style.display = 'block';
    canvas.height = window.innerHeight;
    canvas.width = window.innerWidth;
    const circularController = new WebGLCircularControl();
    circularController.on("buttonPress",(data)=>{
      this.emit('buttonPress',data);
    })
  }

  public removeEventListeners() {}

  getElement() {
    return Menu;
  }
}
